import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChargesDetailsComponent } from './charges-details/charges-details.component';

const chargesModuleRoutes: Routes = [{ path: 'charges/:cnpj/:id', component: ChargesDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(chargesModuleRoutes)],
  exports: [RouterModule],
})
export class ChargesRoutingModule {}
